import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationChannels } from '@fitness-force/enum';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { PlanBreakUpCalculationRequest, PlanBreakUpCalculationResponse, StaffDiscountCalculationRequest, SignUpRequest, SignUpResponse, ChargeBreakUpCalculationRequest, ClientOrderResponse, ChargeBreakUpStaffCalculationRequest, ChargeCreateRequest, MidCycleAddonBreakupRequest, AddonBreakUpResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, throwError, Observable, map } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';


@Injectable({
  providedIn: 'root'
})
export class PlansubscriptionService {
  private http = inject(HttpClient);
  private route = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  getPlanBreakUpCalculation(tenant_id: number, subscription_plan_id: number, planBreakUpCalculationRequest: PlanBreakUpCalculationRequest): Observable<PlanBreakUpCalculationResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.PLAN_BREAKUP_CALCULATION
      .replace('{tenant_id}', tenant_id.toString())
      .replace('{plan_id}', subscription_plan_id.toString())
      , planBreakUpCalculationRequest
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getStaffDiscountCalculation(tenant_id: number, subscription_plan_id: number, staffDiscountCalculationRequest: StaffDiscountCalculationRequest)
    : Observable<PlanBreakUpCalculationResponse> {
    return this.http
      .post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.STAFF_DISCOUNT_CALCULATION
        .replace('{tenant_id}', tenant_id.toString())
        .replace('{plan_id}', subscription_plan_id.toString())
        , staffDiscountCalculationRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  SubscriptionSignup(tenant_id: number, client_id: number, SignUpRequest: SignUpRequest)
    : Observable<SignUpResponse> {
    return this.http
      .post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.SUBSCRIPTION_SIGNUP
        .replace('{tenant_id}', tenant_id.toString())
        .replace('{client_id}', client_id.toString())
        , SignUpRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  CreateCharge(tenant_id: number, client_id: number, chargeCreateRequest: ChargeCreateRequest)
    : Observable<ClientOrderResponse> {
    return this.http
      .post(environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGES.CREATE_CHARGES
        .replace('{tenant_id}', tenant_id.toString())
        .replace('{client_id}', client_id.toString())
        , chargeCreateRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getChargeBreakUpCalculation(tenant_id: number, planBreakUpCalculationRequest: ChargeBreakUpCalculationRequest): Observable<PlanBreakUpCalculationResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGES.CHARGE_BREAKUP_CALCULATION
      .replace('{tenant_id}', tenant_id.toString())
      , planBreakUpCalculationRequest
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getStaffDiscountChargeCalculation(tenant_id: number, chargeBreakUpStaffCalculationRequest: ChargeBreakUpStaffCalculationRequest)
    : Observable<PlanBreakUpCalculationResponse> {
    return this.http
      .post(environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGES.CHARGE_STAFF_DISCOUNT_CALCULATION
        .replace('{tenant_id}', tenant_id.toString())
        , chargeBreakUpStaffCalculationRequest
        , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getAddonBreakUpCalculation(tenant_id: number, clientId: number, subscriptionId: number, request: MidCycleAddonBreakupRequest): Observable<AddonBreakUpResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.MID_CYCLE_ADDON_BREAKUP
      .replace('{tenant_id}', tenant_id.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{subscription_id}', subscriptionId.toString())
      , request
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ClientSubscriptionAddon(tenant_id: number, clientId: number, subscriptionId: number, request: SignUpRequest): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.MID_CYCLE_ADDON
      .replace('{tenant_id}', tenant_id.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{subscription_id}', subscriptionId.toString())
      , request
      , this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
}
